import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

const WATCH_KEYS = new Set(['access_token', 'refresh_token', 'user', 'auth_remember_me']);

/** 其他标签页登录/退出时，同步本页 auth 状态，避免 token 与 zustand 用户角色不一致 */
const AuthCrossTabSync: React.FC = () => {
  const initAuth = useAuthStore((state) => state.initAuth);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (!event.key || !WATCH_KEYS.has(event.key)) return;
      void initAuth();
    };
    const onForbidden = () => {
      void initAuth();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('lce:auth-forbidden', onForbidden);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('lce:auth-forbidden', onForbidden);
    };
  }, [initAuth]);

  return null;
};

export default AuthCrossTabSync;
